import React, { useState } from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import { faBook } from '@fortawesome/free-solid-svg-icons';
import styles from './SocialProfiles.module.css';

interface SocialProfile {
  name: string;
  username: string;
  url: string;
  icon: any;
  avatar: string;
}

const profiles: SocialProfile[] = [
  {
    name: 'Instagram',
    username: '@morgan.w3st',
    url: 'https://instagram.com/morgan.w3st',
    icon: faInstagram,
    avatar: '/instagram-avatar.jpg'
  },
  {
    name: 'LinkedIn',
    username: 'Morgan West',
    url: 'https://www.linkedin.com/in/mr-west/',
    icon: faLinkedin,
    avatar: '/linkedin-avatar.jpg'
  },
  {
    name: 'GitHub',
    username: 'mrw6863',
    url: 'https://github.com/mrw6863',
    icon: faGithub,
    avatar: '/github-avatar.jpg'
  },
  {
    name: 'Goodreads',
    username: 'Morgan',
    url: 'https://www.goodreads.com/user/show/116604895-morgan',
    icon: faBook,
    avatar: '/goodreads-avatar.jpg'
  }
];

const SocialProfiles: React.FC = () => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const handleProfileClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box className={styles.container}>
      <Typography variant="h6" className={styles.sectionTitle}>
        OTHER PROFILES
      </Typography>
      
      <Box className={styles.profilesList}>
        {profiles.map((profile, index) => (
          <Box
            key={profile.name}
            className={styles.profileItem}
            onClick={() => handleProfileClick(profile.url)}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <Box className={styles.profileLeft}>
              <Avatar className={styles.avatar}>
                <FontAwesomeIcon icon={profile.icon} />
              </Avatar>
            </Box>
            
            <Box className={styles.profileCenter}>
              <Typography className={styles.profileName}>
                {profile.name}
              </Typography>
              <Typography className={styles.profileUsername}>
                {profile.username}
              </Typography>
            </Box>
            
            <Box className={styles.profileRight}>
              <button
                className={`${styles.plusButton} ${
                  hoveredIndex === index ? styles.plusButtonHovered : ''
                }`}
              >
                <FontAwesomeIcon icon={faPlus} />
              </button>
            </Box>
          </Box>
        ))}
      </Box>

      {/* TODO: Add "Show More Accounts" text link that opens a sliding menu from the right with a scrollable list of all online accounts */}
    </Box>
  );
};

export default SocialProfiles;